import Image from '@tiptap/extension-image';

const CustomImageResizable = Image.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                default: 'width: 100%; height: auto; cursor: pointer;',
                parseHTML: (element) => {
                    const width = element.getAttribute('width');
                    return width
                        ? `width: ${width}px; height: auto; cursor: pointer;`
                        : `${element.style.cssText}`;
                },
            },
        };
    },
    addNodeView() {
        return ({ node, editor, getPos }) => {
            const {
                view,
                options: { editable },
            } = editor;
            const { style } = node.attrs;
            const $wrapper = document.createElement('div');
            const $container = document.createElement('div');
            const $img = document.createElement('img');

            const dispatchNodeView = () => {
                if (typeof getPos === 'function') {
                    const newAttrs = {
                        ...node.attrs,
                        style: `${$img.style.cssText}`,
                    };
                    view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, newAttrs));
                }
            };

            $wrapper.appendChild($container);

            $container.setAttribute('style', `${style}`);
            $container.appendChild($img);

            Object.entries(node.attrs).forEach(([key, value]) => {
                if (value === undefined || value === null) return;
                $img.setAttribute(key, value);
            });

            if (!editable) return { dom: $container };
            const isMobile = document.documentElement.clientWidth < 768;
            const dotPosition = isMobile ? '-8px' : '-5px';
            const dotsPosition = [
                `top: ${dotPosition}; left: ${dotPosition}; cursor: nwse-resize;`,
                `top: ${dotPosition}; right: ${dotPosition}; cursor: nesw-resize;`,
                `bottom: ${dotPosition}; left: ${dotPosition}; cursor: nesw-resize;`,
                `bottom: ${dotPosition}; right: ${dotPosition}; cursor: nwse-resize;`,
            ];

            let isResizing = false;
            let startX = 0;
            let startWidth = 0;

            $container.addEventListener('click', () => {
                //remove remaining dots
                const isMobile = document.documentElement.clientWidth < 768;
                isMobile && document.querySelector('.ProseMirror-focused')?.blur();

                if ($container.childElementCount > 1) {
                    for (let i = 0; i < 4; i++) {
                        $container.removeChild($container.lastChild);
                    }
                }

                //#829CFF => --colors-common-border-informative
                $container.setAttribute(
                    'style',
                    `position: relative; border: 1px solid #829CFF; border-radius: 4px; ${style} cursor: pointer;`,
                );

                Array.from({ length: 4 }, (_, index) => {
                    const $dot = document.createElement('div');
                    //#829CFF => --colors-common-border-informative
                    //#FFFFFF => --colors-component-background-actionable-default
                    $dot.setAttribute(
                        'style',
                        `position: absolute; width: ${isMobile ? 16 : 10}px; height: ${
                            isMobile ? 16 : 10
                        }px; background-color: #FFFFFF; border: 1px solid #829CFF; ${
                            dotsPosition[index]
                        }`,
                    );

                    $dot.addEventListener('mousedown', (e) => {
                        e.preventDefault();
                        isResizing = true;
                        startX = e.clientX;
                        startWidth = $container.offsetWidth;

                        const onMouseMove = (e) => {
                            if (!isResizing) return;
                            const deltaX =
                                index % 2 === 0 ? -(e.clientX - startX) : e.clientX - startX;

                            const newWidth = startWidth + deltaX;

                            $container.style.width = newWidth + 'px';

                            $img.style.width = newWidth + 'px';
                        };

                        const onMouseUp = () => {
                            if (isResizing) {
                                isResizing = false;
                            }
                            dispatchNodeView();

                            document.removeEventListener('mousemove', onMouseMove);
                            document.removeEventListener('mouseup', onMouseUp);
                        };

                        document.addEventListener('mousemove', onMouseMove);
                        document.addEventListener('mouseup', onMouseUp);
                    });

                    $dot.addEventListener(
                        'touchstart',
                        (e) => {
                            e.cancelable && e.preventDefault();
                            isResizing = true;
                            startX = e.touches[0].clientX;
                            startWidth = $container.offsetWidth;

                            const onTouchMove = (e) => {
                                if (!isResizing) return;
                                const deltaX =
                                    index % 2 === 0
                                        ? -(e.touches[0].clientX - startX)
                                        : e.touches[0].clientX - startX;

                                const newWidth = startWidth + deltaX;

                                $container.style.width = newWidth + 'px';

                                $img.style.width = newWidth + 'px';
                            };

                            const onTouchEnd = () => {
                                if (isResizing) {
                                    isResizing = false;
                                }
                                dispatchNodeView();

                                document.removeEventListener('touchmove', onTouchMove);
                                document.removeEventListener('touchend', onTouchEnd);
                            };

                            document.addEventListener('touchmove', onTouchMove);
                            document.addEventListener('touchend', onTouchEnd);
                        },
                        { passive: false },
                    );
                    $container.appendChild($dot);
                });
            });

            document.addEventListener('click', (e) => {
                const $target = e.target;
                const isClickInside = $container.contains($target);

                if (!isClickInside) {
                    const containerStyle = $container.getAttribute('style');
                    //#829CFF => --colors-common-border-informative
                    const newStyle = containerStyle?.replace(
                        'border: 1px solid #829CFF; border-radius: 4px;',
                        '',
                    );
                    $container.setAttribute('style', newStyle);

                    if ($container.childElementCount > 1) {
                        for (let i = 0; i < 4; i++) {
                            $container.removeChild($container.lastChild);
                        }
                    }
                }
            });

            return {
                dom: $wrapper,
            };
        };
    },
    addOptions() {
        return {
            ...this.parent?.(),
            inline: true,
        }
    }
});

export default CustomImageResizable;
